import React from "react";
import IconEmpty from "../../assets/iconEmpty.svg";

const NoneItem = () => {
  return (
    <div className="w-full text-center h-[50vh] flex flex-col items-center py-32">
      <div className="text-black rounded-full bg-gray-200 p-4 flex justify-center w-16 h-16 items-center">
        <img src={IconEmpty} className="w-6 h-6" />
      </div>
      <div className="my-3">
        <p className="text-[18px] font-bold">
          현재 카테고리 최적화 작업 중입니다.
        </p>
      </div>
      <div className="text-[12px] text-[#666666]">
        <p>조금만 기다려 주시면</p>
        <p>흥미로운 캠페인으로 찾아 뵙겠습니다.</p>
      </div>
    </div>
  );
};

export default NoneItem;
